import { createSelector } from 'reselect'

export type PersonaPermissions = {
  canViewUsers: boolean
  canAddUsers: boolean
  canUpdateUsers: boolean
  canUpdatePostingDate: boolean
  canViewIntegrations: boolean
  canCreatePayment: boolean
  canViewTransactionMatching: boolean
  canUpdateDocument: boolean
  canViewAccountSettings: boolean
}
export type SelectedPersona = {
  companyID: string
  roleID: string
  company: string
  role: string
  displayFields: Record<string, boolean>
  permissions: { name: string; id: number }[]
} & PersonaPermissions
const isIZForwardingEmail = (method) => {
  return method?.type?.name === 'ForwardingIZEmail'
}

const getForwardingIZEmailContactMethod = ({ contactMethods }) => contactMethods
const getRegisteringUser = ({ user }) => user.registeringUser
const getRegisterUserError = ({ user }) => user.registerUserError
const getSelectedPersona = ({ user }) => user.selectedPersona
const getUpdatingUser = ({ user }) => user.updatingUser
const getUserProfile = ({ user }) => user.profile
const getUserProfileFetched = ({ user }) => user.profileFetched

const userSelectors = {
  getRegisteringUser: createSelector([getRegisteringUser], (registeringUser) => {
    return registeringUser
  }),
  getRegisterUserError: createSelector([getRegisterUserError], (registerUserError) => {
    return registerUserError
  }),
  getSelectedPersona: createSelector([getSelectedPersona], (persona): SelectedPersona => {
    const permissions = persona?.permissions?.map((perm) => perm.name) || []

    return {
      companyID: persona?.company?.id,
      roleID: persona?.role?.id,
      company: persona?.company?.name,
      role: persona?.role?.name,
      displayFields: persona?.displayFields,
      permissions: permissions,
      canViewUsers: permissions.includes('users:get'),
      canAddUsers: permissions.includes('users:create'),
      canUpdateUsers: permissions.includes('users:update'),
      canUpdatePostingDate: permissions.includes('posting-date:update'),
      canViewIntegrations: permissions.includes('integrations:get'),
      canCreatePayment: permissions.includes('payments:create'),
      canViewTransactionMatching: !permissions.includes('transaction-matching:!get'),
      canUpdateDocument: permissions.includes('documents:update'),
      canViewAccountSettings: permissions.includes('account-settings:get'),
    }
  }),
  getUpdatingUser: createSelector([getUpdatingUser], (updatingUser) => {
    return updatingUser
  }),
  getForwardingIZEmail: createSelector([getForwardingIZEmailContactMethod], (contactMethod) => {
    return contactMethod?.find(isIZForwardingEmail)?.value
  }),
  getUserProfile: createSelector(getUserProfile, (userProfile) => userProfile),
  getUserProfileFetched: createSelector(getUserProfileFetched, (profileFetched) => profileFetched),
}

export default userSelectors
